import { faPlus, faSlidersUp } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './RateRulesIsEmpty.module.scss';
import Button from 'components/UI/V3/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface RateRulesIsEmptyProps {
    title?: string;
    text?: string;
    showButton?: boolean;
    onClick?: () => void;
    className?: string;
}

const RateRulesIsEmpty: FunctionComponent<RateRulesIsEmptyProps> = props => {
    const {
        title = 'Rate Rules',
        text = 'Click the "Add Rate Rule" button to add your first one',
        showButton = true
    } = props;

    return (
        <div className={clsx(styles.baseContainer, props.className)}>
            <div className={styles.wrapper}>
                <div className={clsx(styles.icon)}>
                    <FontAwesomeIcon
                        icon={faSlidersUp}
                        aria-hidden="true"
                    />
                </div>
                <h1 className={clsx(styles.title)}>{title}</h1>
                <p className={clsx(styles.paragraph)}>{text}</p>

                {showButton && (
                    <div className={styles.buttonContainer}>
                        <Button
                            label="Add Rate Rule"
                            size="large"
                            variant="primary"
                            leftIcon={faPlus}
                            onClick={props.onClick}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default RateRulesIsEmpty;
